<template>
    <nav>
        <IconBurger class="burger" :color="config.COLOR_PRIMARY" @click="onBurger"/>
        <router-link tag="img" class="logo" :src="config.NAVBAR_LOGO" :to="welcome"/>
    </nav>
</template>
<script>
import { SolutionConsumer, CoreConsumer } from '../../mixins';

export default {
    name: 'Navbar',
    mixins: [SolutionConsumer, CoreConsumer],
    methods: {
        onBurger () {
            this.$emit('burger');
        },
    },
};
</script>
<style scoped lang="scss">
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: $white;
    box-shadow: 0 6px 6px 0 rgba($black, .05);
    // Fix for box-shadow over next sibling that has a background image
    position: relative;
    z-index: 1;

    > .logo {
        height: 32px;
        cursor: pointer;
    }
}
</style>
